import { useNotification } from '../components/ui/NotificationSystem/NotificationContext';

export const useNotifications = () => {
  const { addNotification, removeNotification, clearAllNotifications } = useNotification();

  const showSuccess = (message: string, title?: string, options?: { duration?: number; persistent?: boolean }) => {
    addNotification({
      type: 'success',
      message,
      title,
      ...options,
    });
  };

  const showWarning = (message: string, title?: string, options?: { duration?: number; persistent?: boolean }) => {
    addNotification({
      type: 'warning',
      message,
      title,
      ...options,
    });
  };

  const showError = (message: string, title?: string, options?: { duration?: number; persistent?: boolean }) => {
    addNotification({
      type: 'error',
      message,
      title,
      ...options,
    });
  };

  const showInfo = (message: string, title?: string, options?: { duration?: number; persistent?: boolean }) => {
    addNotification({
      type: 'info',
      message,
      title,
      ...options,
    });
  };

  return {
    showSuccess,
    showWarning,
    showError,
    showInfo,
    removeNotification,
    clearAllNotifications,
  };
};